import Store from './Store';
import { captureBusinessError } from './sentry';

function randomString(length) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split(
    ''
  );

  if (!length) {
    length = Math.floor(Math.random() * chars.length);
  }

  var str = '';
  for (var i = 0; i < length; i++) {
    str += chars[Math.floor(Math.random() * chars.length)];
  }
  return str;
}
let uid = Store.get('uid');
if (!uid) {
  uid = randomString(8);
  Store.set('uid', uid);
}
const slog = {
  log: (str) => {
    window.logger.info(str);
  },
  info: (str) => {
    window.logger.info(str);
  },
  warn: (str) => {
    window.logger.warn(str);
  },
  error: (str) => {
    window.logger.error(str);
    try {
      if (str instanceof Error) {
        // window._Sentry && window._Sentry.captureException(str);
      }
    } catch (error) {
      // console.error(error);
      // 处理错误
    }
  },
  capture(err) {
    try {
      window.logger.error(err);
      captureBusinessError(err, {
        name: 'slog_capture'
      });
    } catch (error) {
      // console.error(error);
      // 处理错误
    }
  }
};

export default slog;
